import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { PlanRecommendationApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = PlanRecommendationApiClient;
export const PlanRecommendationExtension = createModuleExtension({
  extensionName: 'planRecommendationExtension',
  Provider,
  SDK: {
    planRecommendationApiClient: client
  }
});
//# sourceMappingURL=plan-recommendation.extension.js.map